<template>
	<div class="fill-height">
		<top-toolbar
			:routes="routes"
			:is-connected="isConnected"
			:is-manager="isManager"
			:user="user"
			v-if="!isEditingGame && isAdmin"
		/>
		<v-row align-content="center" justify="center">
			<v-col>
				<games-toolbar />
			</v-col>
		</v-row>
		<user-side-menu :isOpen="isSideMenuOpen" />
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align-content="center" justify="center">
					<v-col cols="12">
						<router-view />
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import TopToolbar from "src/scaffoldings/TopToolbar";
import GamesToolbar from "./components/GamesToolbar";
import UserSideMenu from "./components/UserSideMenu";

export default {
	components: {
		GamesToolbar,
		TopToolbar,
		UserSideMenu
	},
	prop: {
		source: String
	},
	data: () => ({
		drawer: false,
	}),
	computed: {
		config() {
			return this.$store.state.ConfigModule;
		},
		isSideMenuOpen() {
			return false;
		},
		user() {
			return this.$store.state.AuthModule.user;
		},
		defaultRouter() {
			return this.config.routes.default;
		},
		routes() {
			return this.config.routes.routes[this.defaultRouter].routes;
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		isManager() {
			return this.$store.getters.isManager;
		},
		isConnected() {
			return this.$store.getters.isConnected;
		},
		isEditingGame() {
			return this.$store.getters.showInToolbar;
		},
		mainContainerLgSize() {
			if(this.$route.name === 'game-form' || this.$route.name === 'games-page') {
				return 12;
			}
			return 10;
		}
	},
	created() {
		if (window.innerWidth > 1264) {
			this.drawer = true;
		}
	}
};
</script>

<style>
	.v-main {
		position: relative;
	}
</style>
